import { io } from "socket.io-client";
export const socket = io("http://10.40.40.208:5000");
